<template>

  <drag-modal :visible="$store.state.dislog.twos" @cancel="reset" :title='"添加进度-" + litetit' width='860px'
    :class='{ "editbox": Edit }'>
    <div class="navbox" v-if='Edit'>
      <Nscroll @getIndex='see' @delCopy='copydel' :openEdit='openEdit'></Nscroll>
      <div class="intopbtn" v-if='!isAllDis'>
        <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
          <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
        </a-popconfirm> -->
        <a-popconfirm title="确认删除当前进度吗?" ok-text="确定" cancel-text="取消" @confirm="delStep" v-if="
          StepLite != 181 && $store.state.DisForm.infoList &&
          $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.del)
        ">
          <a-button type="danger" icon="delete" style="margin-left: 12px">删除</a-button>
        </a-popconfirm>
        <a-button icon="edit"
          v-if='$common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) && $store.getters.publicPower'
          style="margin-left:10px;" @click='openEdit = !openEdit'>{{ openEdit ? "修改" : "取消修改" }}</a-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="twobox ">
        <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 12 }" :wrapper-col="{ span: 24 }">
          <div class="ntwoform">
            <a-row :gutter="24">
              <a-col :span="8" v-if="StepLite == 20 || StepLite == 35">
                <a-form-model-item label="诉调时间：" prop="time"
                  :rules="{ required: true, message: '请选择诉调时间', trigger: 'change' }" labelAlign="left">
                  <a-date-picker v-model="form.time" :placeholder="!openEdit ? '请选择诉调时间' : ''" type="date"
                    valueFormat="YYYY-MM-DD HH:mm:ss" :disabled='openEdit' style="width: 100%;" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="StepLite == 20 || StepLite == 35">
                <a-form-model-item label="调解案号" labelAlign="left">
                  <a-input v-model="form.no" :placeholder="!openEdit ? '请输入调解案号' : ''" :disabled='openEdit' v-if='!loading'
                    style="width: 100%;" />
                </a-form-model-item>
              </a-col>
              <a-col :span="8" v-if="StepLite > 190">
                <a-form-model-item label="和解时间：" prop="time"
                  :rules="{ required: true, message: '请选择和解时间', trigger: 'change' }" labelAlign="left">
                  <a-date-picker v-model="form.time" :placeholder="!openEdit ? '请选择和解时间' : ''" type="date"
                    valueFormat="YYYY-MM-DD HH:mm:ss" :disabled='openEdit' style="width: 100%;" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-form-model-item label="承办人" labelAlign="left" style="margin-top:-15px;">
                  <div v-for="(item, index) in form.uname" :key="index" class="form-item-row">
                    <a-form-model-item
                      :prop="`uname.${index}.v`"
                      :rules="unameRules"
                      class="no-margin"
                    >
                      <a-input
                        v-model="item.v"
                        :placeholder="!openEdit ? '请输入承办人' : ''"
                        :disabled="openEdit"
                      />
                    </a-form-model-item>
                  </div>
                </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="联系方式" labelAlign="left" style="margin-top:-15px;">
                  <div v-for="(item, index) in form.tel" :key="index" class="form-item-row">
                    <a-form-model-item
                      :prop="`tel.${index}.v`"
                      :rules="telRules"
                      class="no-margin"
                    >
                      <a-input
                        v-model="item.v"
                        :placeholder="!openEdit ? '请输入联系方式' : ''"
                        :disabled="openEdit"
                      />
                    </a-form-model-item>
                    <div class="btns" v-if="!openEdit">
                      <a-icon type="plus-circle" class="add" @click="add" v-if="index == 0" />
                      <a-icon type="minus-circle" class="del" @click="dels(index)" v-if="index > 0"/>
                    </div>
                  </div>
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-form-model-item :label="StepLite == 20 || StepLite == 35 ? '调解进程' : '和解进程'" v-if='!loading'
              labelAlign="left" style="margin-top: -20px;">
              <Textarea :content='form.content' @contentVal='(element) => { form.content = element }' :edit='openEdit'
                :keyArr="['time', 'user']"> </Textarea>
              <!-- <Textarea :content='form.content' @contentVal='(element)=>{form.content=element}' :edit='openEdit'> </Textarea> -->
            </a-form-model-item>
          </div>
          <div>
            <div class="licter" v-if="!openEdit">
              <label>补充材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon" style="margin-bottom:5px;">
              <div class="ilikebox" v-for="(i, index) in form.supp" :key="index">
                <div class="likebox" v-if="i.type == 1">
                  <div class="htit">
                    补充材料：电子
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="平台名称" :prop="'supp.' + index + '.platform'" :rules="{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.platform" :disabled='openEdit' placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{ span: 6 }" :wrapper-col="{ span: 24 }"
                        :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 2">
                  <div class="htit">
                    补充材料：微信
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="对方微信号" :prop="'supp.' + index + '.wx'" :rules="{
                        required: true,
                        message: '请输入对方微信号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.wx" :disabled='openEdit' placeholder="请输入对方微信号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }"
                        :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 3">
                  <div class="htit">
                    补充材料：现场
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="补充提交人" :prop="'supp.' + index + '.submiter'" :rules="{
                        required: true,
                        message: '请输入补充提交人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.submiter" :disabled='openEdit' placeholder="请输入补充提交人" />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 4">
                  <div class="htit">
                    补充材料：邮寄
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="单号" :prop="'supp.' + index + '.ship_no'" :rules="{
                        required: true,
                        message: '请输入单号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.ship_no" :disabled='openEdit' placeholder="请输入单号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'supp.' + index + '.tel'" :rules="{
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.tel" :disabled='openEdit' placeholder="请输入联系方式" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="收件人" :prop="'supp.' + index + '.receive_name'" :rules="{
                        required: true,
                        message: '请输入收件人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.receive_name" :disabled='openEdit' placeholder="请输入收件人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="寄出时间" :prop="'supp.' + index + '.ship_time'" :rules="{
                        required: true,
                        message: '请选择寄出时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="">
                        <label v-if="openEdit">{{
                          i.gout == 'a'
                            ? '签收时间:'
                            : i.gout == 'b'
                              ? '拒收时间:'
                              : '无'
                        }}</label>
                        <a-radio-group v-model="i.gout" :disabled="openEdit" style="white-space: nowrap" size="small"
                          v-else>
                          <a-radio-button :value="null" style="
                              width: 64px;
                              text-align: center;
                              font-size: 0.75rem;
                            ">无</a-radio-button>
                          <a-radio-button :value="'a'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="i.gout == 'a'"
                          :disabled="openEdit" style="width: 100%" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" v-if="i.gout == 'b'" />
                        <a-input disabled v-if="!i.gout" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="收件地址" :prop="'supp.' + index + '.addr'" :rules="{
                        required: true,
                        message: '请输入收件地址',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.addr" :disabled="openEdit" type="textarea" placeholder="请输入收件地址" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>

            <div class="licter" v-if="!openEdit">
              <label>接收材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1, 1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2, 1)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3, 1)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4, 1)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon">
              <div class="ilikebox" v-for="(i, index) in form.accept_file" :key="index">
                <div class="likebox" v-if="i.type == 1">
                  <div class="htit">
                    接收材料：电子
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'" :rules="{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.platform" :disabled='openEdit' placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 2">
                  <div class="htit">
                    接收材料：微信
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'" :rules="{
                        required: true,
                        message: '请输入对方微信号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.wx" :disabled='openEdit' placeholder="请输入对方微信号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 3">
                  <div class="htit">
                    接收材料：现场
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'" :rules="{
                        required: true,
                        message: '请输入接收人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.submiter" :disabled='openEdit' placeholder="请输入接收人" />
                      </a-form-model-item>
                    </a-col>

                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 4">
                  <div class="htit">
                    接收材料：邮寄
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'" :rules="{
                        required: true,
                        message: '请输入单号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.ship_no" :disabled='openEdit' placeholder="请输入单号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                        <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                      </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'" :rules="{
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.tel" :disabled='openEdit' placeholder="请输入联系方式" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled='openEdit' placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'" :rules="{
                        required: true,
                        message: '请输入接收人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.receive_name" :disabled='openEdit' placeholder="请输入接收人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'" :rules="{
                        required: true,
                        message: '请选择寄出时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="">
                        <label v-if="openEdit">{{
                          i.gout == 'a'
                            ? '签收时间:'
                            : i.gout == 'b'
                              ? '拒收时间:'
                              : '无'
                        }}</label>
                        <a-radio-group v-model="i.gout" :disabled="openEdit" size="small" style="white-space: nowrap"
                          v-else>
                          <a-radio-button :value="null" style="
                              width: 64px;
                              text-align: center;
                              font-size: 0.75rem;
                            ">无</a-radio-button>
                          <a-radio-button :value="'a'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="
                              width: 65px;
                              font-size: 0.75rem;
                              text-align: center;
                            ">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="i.gout == 'a'"
                          :disabled="openEdit" style="width: 100%" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" v-if="i.gout == 'b'" />
                        <a-input disabled v-if="!i.gout" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="收件地址" :prop="'accept_file.' + index + '.addr'" :label-col="{ span: 12 }"
                        :wrapper-col="{ span: 24 }" :rules="{
                          required: true,
                          message: '请输入收件地址',
                          trigger: 'blur',
                        }">
                        <a-input v-model="i.addr" :disabled="openEdit" type="textarea" placeholder="请输入收件地址" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'"
                        :label-col="{ span: 12 }" :wrapper-col="{ span: 24 }">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item labelAlign="left" :wrapper-col="{ span: 24 }" prop="files"
            :rules="{ required: false, message: '请上传附件', trigger: 'change' }">
            <Upload @isDisabled="parentHandle" :fList='List' @upFileAfter='lisUpload' :disabled="openEdit" :edit='openEdit'
              v-if='!loading' />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if='!openEdit' style="text-align:center;">
            <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button :disabled="disabledShow" type="primary" style="width:148px;">
                提交
              </a-button>
            </a-popconfirm>
            <a-button style=" margin-left: 20px;width:148px;background:#B2C9E1;color:#fff;" @click='reset'>取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-spin>
  </drag-modal>

</template>
<script>
import Textarea from '@/components/textarea'
import liteKey from "./../liteKey.json"
import Upload from "@/components/uploads"
import { twosAdd, twosEdit, twosDetails, delJd } from "@/server/speed"
import { stepFiles } from "@/server/debtor"
import Nscroll from "@/components/nscroll"
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Twos',
  components: {
    Textarea, Upload, Nscroll
  },
  data() {
    return {
      List: [],
      isAllDis: this.$route.query.t,
      StepLite: this.$store.state.StepLite,
      loading: true,
      openEdit: false,
      form: {
        accept_file: [],
        supp: [],
        content: [{ content: '' }],
        files: [],
        time: null,
        uname: [{ v: '' }],
        tel: [{ v: '' }],
        no: null,
        step: 0
      },
      rules: {},
      disabledShow: false,
      unameRules: [
        {
          validator: (rule, value, cb) => {
            const i = rule.field.split(".")[1];
            const hasTel = this.form.tel[i].v.trim();
            if (hasTel && !value.trim()) return cb("请填写对应承办人");
            cb();
          },
          trigger: "blur"
        }
      ],

      // 电话校验：承办人填了 → 必须填电话
      telRules: [
        {
          validator: (rule, value, cb) => {
            const i = rule.field.split(".")[1];
            const hasName = this.form.uname[i].v.trim();
            if (hasName && !value.trim()) return cb("请填写对应联系方式");
            cb();
          },
          trigger: "blur"
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'litetit',
      'Edit'
    ]),
  },
  created() {
    if (this.Edit) {
      this.$nextTick(() => {
        twosDetails({ cause_id: this.$store.state.cause.id, step: this.StepLite }).then(e => {
          e.list.map(ele => {
            ele.stz.supp = Object.keys(ele.stz.supp).map(key => ele.stz.supp[key])
            ele.stz.accept_file = Object.keys(ele.stz.accept_file).map(key => ele.stz.accept_file[key])
            ele.stz.content = !ele.stz.content || (ele.stz.content && ele.stz.content.length == 0) ? [{}] : ele.stz.content
            //   ele.stz.content = JSON.stringify(ele.stz.content) == "{}" ? [{ content: '' }] : Object.keys(ele.stz.content).map(key => ele.stz.content[key]);
            ele.stz.supp.map(element => {
              if (element.type * 1 == 4) {
                element.gout = (!element.receive_time && !element.return_time) ? null : (element.receive_time ? "a" : "b")
              }
            })
            ele.stz.accept_file.map(element => {
              if (element.type * 1 == 4) {
                element.gout = (!element.receive_time && !element.return_time) ? null : (element.receive_time ? "a" : "b")
              }
            })
            ele.stz.uname = ele.stz.uname ? ele.stz.uname.split(",").map(ele => { return { v: ele } }) : [{ v: '' }]
            ele.stz.tel = ele.stz.tel ? ele.stz.tel.split(",").map(ele => { return { v: ele } }) : [{ v: '' }]
          })
          this.$store.dispatch("settime", e.list[0].stz.update_time)
          this.Infokey({ key: 'infoList', value: e.list })
          this.see(0)
        })
        this.openEdit = true;
      })
    } else {
      this.loading = false;
    }
  },
  methods: {
    parentHandle(data) {
      this.disabledShow = data
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove'
    }),
    delStep() {
      let curIndex = this.$store.state.DisForm.curIndex
      let step_id = this.$store.state.DisForm.infoList[curIndex].id
      delJd({ step_id: step_id }).then(e => {
        this.$message.success("已提交审核")
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    async copydel(index) {        //删除进度
      await this.Newdel({ index: index, formKey: ["content", "files", "time", "uname", "tel", "no"], valkey: "stz" }).then(e => {
        this.form = JSON.parse(JSON.stringify(e));
        this.loading = false;
      })
    },
    async see(index) {        //查看切换 审批
      this.loading = true;
      let form = this.form;
      this.seeInfo({ index: index, formKey: ["content", "files", "time", "uname", "tel", "no", 'supp', 'accept_file'], valkey: "stz" }).then(e => {
        let form = JSON.parse(JSON.stringify(e));
        form.files.map((ele) => {
          ele.title = ele.origin_name || ele.title
          ele.upload_id = ele.upload_id
          ele.id = ele.id
        })
        this.List = form.files
        this.form = form
        this.loading = false;
      })
    },
    add() {
      this.form.uname.push({ v: '' })
      this.form.tel.push({ v: '' })
    },
    dels(index) {
      this.form.uname.splice(index, 1)
      this.form.tel.splice(index, 1)
    },
    del(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    },
    plusAdd(type, lite) {
      let smForm = {
        type: type,
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    nameTelValid(rule, value, callback) {
      // 获取当前输入框所在下标（巧妙利用视图循环下标）
      const index = rule.field.split('.')[1]
      const unameVal = this.form.uname[index].v || ''
      const telVal = this.form.tel[index].v || ''

      // 规则：只填其中一个 → 报错
      if((unameVal && !telVal)) {
        return callback('请填写对应联系方式')
      }
      if((telVal && !unameVal)) {
        return callback('请填写对应承办人')
      }
      callback()
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          let content = form.content.filter(e => {
            return e.content
          })
          form.content = content;
          form.uname = form.uname.filter(i => i.v).map(i => i.v).join(',')
          form.tel = form.tel.filter(i => i.v).map(i => i.v).join(',')
          for (let val in form) {
            if (!form[val]) {
              delete form[val]
            }
          }
          if (form.files && form.files.length > 0) {
            form.files = form.files.map(ele => {
              return ele.upload_id || ele
            })
          }
          if (form.no) {
            form.no = form.no.replace(/\s/g, '');
          }
          form.supp.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })

          form.accept_file.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })
          let curIndex = this.$store.state.DisForm.curIndex
          let isEditCopyAdd = this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0 ? true : false   //当前是否是在修改下的新增
          form.step = Number(this.StepLite)
          if (this.Edit && !isEditCopyAdd) {      //修改
            let id = this.$store.state.DisForm.infoList[curIndex].stz.id
            form.id = id;
            // return false;
            twosEdit(form).then(e => {
              this.$message.success({ content: '修改成功', key: 'updatable' });
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            twosAdd(form).then(e => {
              this.$message.success({ content: '新增成功', key: 'updatable' });
              this.$parent.$parent.init(this.$store.state.cause.id)
              //   this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset() {
      this.reMove().then(e => {
        this.$refs.forms.resetFields();
        this.$store.dispatch('openkey', { key: 'twos', by: false })
      })

    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
  }
}
</script>
<style lang="less" scoped>
.form-item-row {
  margin-bottom: 12px;
  position: relative;
}
.no-margin {
  margin-bottom: 0 !important;
}
.morebar {
  display: flex;
  margin-bottom: 10px;
  height: 40px;
  align-items: center;
  position: relative;

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
}
.btns {
  position: absolute;
  right: -45px;
  top: 5px;
  // transform: translateY(-50%);
  width: 15%;
  display: flex;
  font-size: 1.25rem;
  justify-content: space-between;
  padding-left: 20px;
  height: 30px;
  align-items: center;

  .i {
    cursor: pointer;
  }

  .add {
    color: #118afc;
  }

  .del {
    color: #f00;
  }
}

.ilikecon {
  max-height: 400px;
  overflow: auto;
}

.intopbtn .rd {
  opacity: 0.8;
  border-color: #ff9800;
  color: #ff9800;
}

.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;

  .htit {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 0;
  }

  /deep/ .ant-form-item-label {
    text-align: left;
  }
}

.licter {
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 0.875rem;
    text-align: right;
    width: 60px;
    color: #333;
    line-height: 30px;
    margin-right: 10px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 0.875rem;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}
</style>